<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <v-card>
      <v-card-title class="text-h5 green darken-1 white--text">
        <v-icon left dark>mdi-message-text</v-icon>
        Send SMS to {{ clientName }}
      </v-card-title>

      <v-card-text class="pt-6">
        <v-alert v-if="!hasCredits" type="warning" outlined dense class="mb-4">
          <v-icon left>mdi-alert</v-icon>
          You have insufficient SMS credits
        </v-alert>

        <v-form ref="form" v-model="valid">
          <v-text-field
            :value="clientPhone"
            label="Recipient Phone Number"
            outlined
            dense
            readonly
            prepend-icon="mdi-phone"
          ></v-text-field>

          <v-textarea
            v-model="message"
            label="Message"
            :rules="[rules.required, rules.maxLength]"
            outlined
            rows="5"
            counter="160"
            hint="Standard SMS is 160 characters"
            persistent-hint
          ></v-textarea>

          <v-card outlined class="mt-4 pa-3">
            <div class="d-flex justify-space-between">
              <span class="text-caption grey--text">Characters:</span>
              <span class="text-caption font-weight-bold"
                >{{ messageLength }}/160</span
              >
            </div>
            <div class="d-flex justify-space-between">
              <span class="text-caption grey--text">SMS Count:</span>
              <span class="text-caption font-weight-bold">{{ smsCount }}</span>
            </div>
          </v-card>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog"> Cancel </v-btn>
        <v-btn
          color="green darken-1"
          dark
          @click="sendSMS"
          :disabled="!valid || !hasCredits || !message"
        >
          <v-icon left>mdi-send</v-icon>
          Send SMS
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SMSDialog",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    clientName: {
      type: String,
      default: "",
    },
    clientPhone: {
      type: String,
      default: "",
    },
    smsCredits: {
      type: Number,
      default: 0,
    },
  },

  data: () => ({
    valid: false,
    message: "",
    rules: {
      required: (v) => !!v || "Message is required",
      maxLength: (v) =>
        (v && v.length <= 640) || "Message is too long (max 640 characters)",
    },
  }),

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    hasCredits() {
      return this.smsCredits > 0;
    },

    messageLength() {
      return this.message ? this.message.length : 0;
    },

    smsCount() {
      if (!this.message) return 0;
      return Math.ceil(this.message.length / 160);
    },
  },

  methods: {
    sendSMS() {
      if (this.$refs.form.validate()) {
        this.$emit("send", this.message);
        this.closeDialog();
      }
    },

    closeDialog() {
      this.$emit("input", false);
      this.$emit("close");
      this.message = "";
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
  },
};
</script>
